import { useCallback, useRef, useState } from 'react';

/**
 * Hülle für Aktionen auf Klick: Eine Ablehnung landet in `error` und damit auf der Seite, nicht als
 * `unhandledrejection` in der Konsole. `busy` bleibt stehen, bis auch das Neuladen danach durch ist.
 * Die Sperre liegt im Ref, weil `busy` den Knopf erst nach dem nächsten Rendern erreicht.
 */
export function useAction() {
  const running = useRef(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<unknown>(null);

  const run = useCallback(async (action: () => Promise<unknown>) => {
    if (running.current) return;
    running.current = true;
    setBusy(true);
    setError(null);
    try {
      await action();
    } catch (err) {
      setError(err);
    } finally {
      running.current = false;
      setBusy(false);
    }
  }, []);

  return { run, busy, error, setError };
}
